import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Короткие уведомления об удавшемся действии.
 *
 * Об ошибках здесь ничего нет намеренно: их показывают сами модалки, рядом с
 * полями, которые надо исправить. Сюда попадает только то, после чего окно
 * закрылось и подтвердить результат больше нечем.
 */
export const useToastStore = defineStore('toast', () => {
  const toasts = ref([]);

  let nextId = 1;

  /**
   * @param {string} text  что произошло, в прошедшем времени
   * @param {number} timeout  через сколько убрать, мс
   */
  function success(text, timeout = 10000) {
    const id = nextId++;

    toasts.value.push({ id, text });

    setTimeout(() => dismiss(id), timeout);

    return id;
  }

  function dismiss(id) {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  }

  return {
    toasts,

    success,
    dismiss
  };
});
